const verificationInitialState = {
  order:              {},
  loading:            false,
  initialStateLoaded: false,
};
export default verificationInitialState;